import { loc } from "../../../../../../core/utils"
import React from "react"

export default function PricingTableHeaders() {
  return (
    <thead>
      <tr>
        <th></th>
        <th>
          HT<small>{loc("/month")}</small>
        </th>
        <th>
          TVA<small>{loc("/month")}</small>
        </th>
        <th>
          TTC<small>{loc("/month")}</small>
        </th>
      </tr>
    </thead>
  )
}

PricingTableHeaders.propTypes = {}
